<div class="login-container">
    <div class="logo">
        <h1>🏢 REHOBOT</h1>
        <p>Panel de Administración</p>
    </div>
    
    <form (ngSubmit)="login()" #loginForm="ngForm">
        <div id="alertContainer" *ngIf="alertMessage">
            <div class="alert" [ngClass]="{'alert-success': alertType === 'success', 'alert-error': alertType === 'error'}">
                {{ alertMessage }}
            </div>
        </div>
        
        <div class="form-group">
            <label for="usuario">Usuario</label>
            <input type="text" id="usuario" name="usuario" [(ngModel)]="credentials.usuario" required autocomplete="username" #username="ngModel">
        </div>
        
        <div class="form-group">
            <label for="password">Contraseña</label>
            <input type="password" id="password" name="password" [(ngModel)]="credentials.password" required autocomplete="current-password" #password="ngModel">
        </div>
        
        <div class="remember-me">
            <input type="checkbox" id="recordar" name="recordar" [(ngModel)]="rememberMe">
            <label for="recordar">Mantener sesión iniciada</label>
        </div>
        
        <button type="submit" class="btn-login" [disabled]="!loginForm.form.valid || isLoading">
            <span *ngIf="!isLoading">Iniciar Sesión</span>
        </button>
        
        <div class="loading" *ngIf="isLoading">
            <div class="spinner"></div>
            <p>Verificando credenciales...</p>
        </div>
    </form>
    
    <div class="footer">
        <p>© 2025 Corporación REHOBOT - Sistema Administrativo</p>
    </div>
</div>